<template>
  <div class="settleInLayout">
    <el-header class="header" height="80px">
      <div class="header-inner w w1200">
        <img class="logo" :src="logo" alt="腾信电商" @click="$router.push('/')" />
      </div>
    </el-header>
    <router-view></router-view>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'settleInLayout',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  computed: {
    logo () {
      return this.$store.state.logo;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.header{
  background-color: #fff;
  box-sizing: border-box;
  .logo{
    height: 60px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/settleInLayout.vue